export default "__VITE_ASSET__4c2e427a__"